const Chip = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 9H15V15H9V9Z" fill={color} />
      <path
        d="M20 6C20 4.897 19.103 4 18 4H16V2H14V4H10V2H8V4H6C4.897 4 4 4.897 4 6V8H2V10H4V14H2V16H4V18C4 19.103 4.897 20 6 20H8V22H10V20H14V22H16V20H18C19.103 20 20 19.103 20 18V16H22V14H20V10H22V8H20V6ZM6 18V6H18L18.002 18H6Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Chip;
